export default {
  TYPE_ONCE_ALL: 'all',
  TYPE_ONCE_ONE_TIME: 'onetime',

  TYPE_MICROSOFT_IT_SERVICE: 'microsoft-it-service'
}